export const KLYDO_YELLOW = '#FFD848';
export const KLYDO_BLACK = '#0C0C0C';
export const KLYDO_WHITE = '#fdfdfd';
// Klydo Studio text tones from the design system's Foundations frame. The MUI
// palette names neither of the faded ones, and they were being retyped inline.
export const TEXT_SECONDARY = 'rgba(255, 255, 255, 0.7)';
export const TEXT_TERTIARY = 'rgba(255, 255, 255, 0.4)';
export const TEXT_DISABLED = 'rgba(255, 255, 255, 0.2)';
// v3 clock info-page text colors (match the Kotlin/Compose theme)
export const CLOCK_INFO_LABEL = '#C1C1C1'; // "By {artist}" label (TooltipTextColor)
export const CLOCK_INFO_MUTED = '#B2B2B2'; // stats / social / created (LeafSettingsHeadingColor)
// Share klydo link page (TK-275)
export const CLOCK_FRAME_BACKGROUND = '#1E1E1E';
export const SHARE_PAGE_BACKGROUND = '#494848';
export const PENDING = '#FFA726';
export const REJECTED = '#F44336';
export const DRAFT = 'rgba(255, 255, 255, 0.7)';
export const APPROVED = '#66BB6A';
export const NATIONAL_HOLIDAY_BACKGROUND_COLOR = 'rgba(255, 216, 72, 0.16)';
export const NATIONAL_HOLIDAY_HOVER_BACKGROUND_COLOR =
  'rgba(255, 216, 72, 0.30)';
export const CALENDAR_EVENT_HOVER_BACKGROUND_COLOR = '#585858';
export const CALENDAR_NOT_IN_MONTH_DAY_COLOR = 'rgba(42, 42, 42, 0.3)';
export const CALENDAR_EVENT_BACKGROUND_COLOR =
  'linear-gradient(0deg, var(--background-paper-elevation-11, #313131) 0%, var(--background-paper-elevation-11, #313131) 100%), #FFF';
